// ** Imports createContext function
import { createContext, useEffect, useState } from "react";

// ** Imports createContextualCan function
import { createContextualCan } from "@casl/react";
import { initialAbility } from "../../configs/acl/initialAbility";
import { useAuth } from "../hooks/useAuth";
import { Ability } from "@casl/ability";
import { getPermissionsUser } from "../Utils";
import { useGetMe } from "../hooks/auth/useGetAuth";
import ability from "../../configs/acl/ability";

// ** Create Context
export const AbilityContext = createContext({});

// ** Init Can Context
export const Can = createContextualCan(AbilityContext.Consumer as any);

export const AbilityProvider = ({ children }) => {
  // const [ability, setAbility] = useState(new Ability(initialAbility));
  // const { user } = useAuth();
  // useEffect(() => {
  //   if (user) {
  //     // const permissions = getPermissionsUser(user.roles, user.permissions);
  //     // setAbility(new Ability(permissions));
  //     localStorage.setItem("@revalida.user", JSON.stringify(user));
  //   }
  // }, [user]);
  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
};
